import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: center;
	justify-content: center;
`;

export const title = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	> p {
		font-size: 1.5rem;
		font-family: nunito-bold;
		color: ${color.interface.darkgray};
	}
`;

export const list = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	overflow: auto;
`;

export const img = styled.div`
	position: relative;
	min-width: 70px;
	min-height: 70px;
	max-width: 70px;
	max-height: 70px;

	display: flex;
	align-items: center;
	justify-content: center;
	> img {
		width: 100%;
		height: 100%;
		min-height: 50px;
		border-radius: 50%;
		background-color: ${color.interface.lightGray2};
	}
`;
